import { mapDTO } from '@twistezo/ts-dto-mapper'

import { SelectOption } from 'components/Select'
import { DomainSlice } from '../types'
import { DomainSliceDTO } from './types'

type From = DomainSliceDTO
type To = SelectOption<DomainSlice>

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ id, name, overriddenByYieldbird, pubAdsServiceRefresh }: From): To => ({
      label: name,
      rawData: {
        id,
        name,
        overriddenByYieldbird,
        pubAdsServiceRefresh,
      },
      value: id,
    }),
  )
